import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Flex, MEDIA_QUERY, ResizeImage } from '@bucketplace/design-system';

import { RaffleButton } from './RaffleButton';
import { RafflePlayer } from './RafflePlayer';

export interface RaffleLayoutProps {
  /** 이미지 URL */
  imageUrl?: string;
  /** 비디오 URL */
  videoUrl?: string;
  /** 버튼 텍스트 */
  buttonText?: string;
  /** 버튼 하단 여백 */
  buttonBottom: number;
  /** 버튼 클릭 핸들러 (edit 모드에서는 undefined) */
  onButtonClick?: () => void;
  /** 버튼 비활성화 여부 */
  disabled?: boolean;
}

export function RaffleLayout({
  imageUrl,
  videoUrl,
  buttonText,
  buttonBottom,
  onButtonClick,
  disabled = false,
}: RaffleLayoutProps): ReactElement {
  return (
    <Flex
      css={css`
        position: relative;
      `}
    >
      { videoUrl
        ? <RafflePlayer videoUrl={videoUrl} poster={imageUrl} />
        : (
          <ResizeImage
            src={imageUrl || ''}
            alt="raffle-event-image"
            objectFit="cover"
            intrinsicAspect={375 / 550}
            style={{
              aspectRatio: '375 / 550',
              display: 'block',
              width: '100%',
            }}
          />
        ) }
      { buttonText && (
        <RaffleButtonContainer buttonBottom={buttonBottom}>
          <RaffleButton
            onClick={onButtonClick}
            disabled={disabled}
          >
            { buttonText }
          </RaffleButton>
        </RaffleButtonContainer>
      ) }
    </Flex>
  );
}

const RaffleButtonContainer = styled.div<{ buttonBottom: number }>`
  position: absolute;
  bottom: ${({ buttonBottom }) => buttonBottom}px;
  left: 16px;
  right: 16px;

  ${MEDIA_QUERY.min('tablet', css`
    left: 19px;
    right: 19px;
  `)}

  ${MEDIA_QUERY.min('desktop', css`
    left: 34px;
    right: 34px;
  `)}
`;
